module.exports = __webpack_public_path__ + "static/media/rs-ig.c5c547b0.svg";